export const DISPLAY_UI_SCALE_MIN = 50;
export const DISPLAY_UI_SCALE_MAX = 150;
export const DISPLAY_UI_SCALE_DEFAULT = 100;

export function normalizeDisplayUiScale(raw: unknown): number {
  const parsed =
    typeof raw === "number"
      ? raw
      : typeof raw === "string"
        ? Number.parseInt(raw, 10)
        : Number.NaN;
  if (!Number.isFinite(parsed)) return DISPLAY_UI_SCALE_DEFAULT;
  return Math.min(DISPLAY_UI_SCALE_MAX, Math.max(DISPLAY_UI_SCALE_MIN, Math.round(parsed)));
}

export function displayUiScaleFactor(scalePercent: number): number {
  return normalizeDisplayUiScale(scalePercent) / 100;
}

export function scaleDisplayPx(value: number, scalePercent: number): number {
  return Math.max(1, Math.round(value * displayUiScaleFactor(scalePercent)));
}

export const DISPLAY_UI_SCALE_PRESETS: { value: number; label: string }[] = [
  { value: 60, label: "Sehr klein" },
  { value: 75, label: "Klein" },
  { value: 85, label: "Kompakt" },
  { value: 100, label: "Standard" },
  { value: 115, label: "Groß" },
];
